import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BuildApp from './BuildApp';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { captureInternalTrafficFromLocation } from './utils/internalTraffic';

// Before the app renders, so a region redirect can't drop ?kibu_internal from the address first.
captureInternalTrafficFromLocation();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* <BuildApp /> */}
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
